import React from 'react';
import { ErrorMessage } from '@common/components/ErrorMessage';
import { Box } from '@components/Box';
import { Field, Input } from '@components/FormElements';
import { Stack } from '@components/Stack';
import { T } from '../../types';

type EmailVerificationProps = {
  value: string;
  onChange: () => void;
  onBlur: () => void;
  error?: string;
  t: T;
};

export const EmailVerificationCode = ({
  error,
  onChange,
  onBlur,
  value,
  t
}: EmailVerificationProps) => {
  return (
    <Stack spacing="small">
      <Field
        label={t('verifyEmailForm.fieldLabel')}
        message={
          error && (
            <Box marginTop="xxsmall">
              <ErrorMessage>{error}</ErrorMessage>
            </Box>
          )
        }
      >
        <Input
          id="verify-email-form-email"
          testID="verify-email-form-email"
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          keyboardType="number-pad"
        />
      </Field>
    </Stack>
  );
};
